export default __webpack_public_path__ + "static/media/Service-3.d2001947.jpg";